import React, { useState } from 'react'
import InputWithSuggestions from 'components/InputWithSuggestions'
import { type InputWithSuggestionsProps } from 'components/InputWithSuggestions/InputWithSuggestions'
import { useDebouncedInput } from 'hooks'
import { type Address, useGetAddressesQuery } from 'types/graphql-generated'

const DEBOUNCE_TIME = 1000
const SEARCH_MIN_LENGTH = 5

interface AddressSearchProps extends InputWithSuggestionsProps<Address> {
  countryIsoCode?: string
}

export const AddressSearch: React.FC<React.PWC<AddressSearchProps>> = ({
  onSelectFromSuggestions,
  countryIsoCode = '',
  onChange,
  ...rest
}) => {
  const [searchString, setSearchString] = useState('')
  const { debouncedValue: debouncedSearchValue } = useDebouncedInput(
    searchString,
    DEBOUNCE_TIME
  )

  const { data: searchData, loading: isLoading } = useGetAddressesQuery({
    variables: {
      input: {
        search: debouncedSearchValue,
        countryIsoCode,
      },
    },
    skip: debouncedSearchValue.length < SEARCH_MIN_LENGTH,
  })

  const addresses = searchData?.addresses || []
  const suggestions = addresses.map((address) => ({
    label: address.fullAddress,
    value: address,
  }))

  return (
    <InputWithSuggestions
      data={suggestions}
      isLoading={isLoading}
      onChange={(event) => {
        setSearchString(event.target.value)
        onChange?.(event)
      }}
      onSelectFromSuggestions={({ label, value }) => {
        onSelectFromSuggestions({
          label,
          value,
        })
        setSearchString(value.title)
      }}
      {...rest}
    />
  )
}
